// (async () => {
//     var e = await import(window.theme.modules.baseComponent);
//     customElements.define(
//         "product-qty",
//         class extends e.default {
//             render() {
//                 (this.currentVariant = +this.getAttribute("variant-id")),
//                     this.listenTo("variantChange", (e, t) => {
//                         (this.currentVariant = t.variant.id), this._rerender(t);
//                     }),
//                     this.listenTo(
//                         "qtyStatusUpdate",
//                         (e, t) => {
//                             this.currentVariant === +t.variantId && this._rerender(t);
//                         },
//                         !1
//                     );
//             }
//             _rerender(e) {
//                 const t = e.html.querySelector("product-qty");
//                 e = this.querySelector("select")?.value;
//                 if (e) {
//                     const r = t.querySelector(`option[value="${e}"]`);
//                     r && r.setAttribute("selected", !0);
//                 }
//                 this.replaceChildren(...t.cloneNode(!0).childNodes);
//             }
//         }
//     );
// })();

document.addEventListener("DOMContentLoaded", function(event) {


      document.getElementsByTagName('body')[0].addEventListener("click", function(e) {
var qtyMinus = document.querySelector('.product-qty-btn-minus');
	var qtyPlus = document.querySelector('.product-qty-btn-plus');
	var qtyInput = document.querySelector('.product-qty-input');
	var nameQty = document.querySelector('[data-prod-qty]');
       if (e.target.closest('button') == qtyMinus) {
        if (qtyInput.value == 1) {
          qtyInput.value = 1;
		  nameQty.value = 1;
        } else {
		  qtyInput.value = +qtyInput.value - 1;
		  nameQty.value = +nameQty.value - 1;
        }
       }
      }, false);
    


      document.getElementsByTagName('body')[0].addEventListener("click", function(e) {
var qtyMinus = document.querySelector('.product-qty-btn-minus');
	var qtyPlus = document.querySelector('.product-qty-btn-plus');
	var qtyInput = document.querySelector('.product-qty-input');
    var nameQty = document.querySelector('[data-prod-qty]');
       if (e.target.closest('button') == qtyPlus) {
		 	qtyInput.value = +qtyInput.value + 1;
			nameQty.value = +nameQty.value + 1;
       }
      }, false);

//   document.getElementsByTagName('body')[0].addEventListener("input", function(e) {
// 	var qtyInput = document.querySelector('.product-qty-input');
// 	var maxValue = +qtyInput.getAttribute('data-variant-qty');
// 	if (e.target == qtyInput) {
//       if (+qtyInput.value > maxValue) {
//       	qtyInput.value = maxValue;
//       }
//     }
//   });
    
});